import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../../api/APIPaths';
import { IAdminUserScheduleData, IScheduleFullEvent } from '.';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { ISection } from '../SectionSlice';
import { IUser } from '../../UserSlice';

export type TAdminGetUserSchedule = {
  userId: string;
  startDate: string;
  endDate: string;
  courseId?: string;
};

export type TAdminGetScheduleById = {
  sectionId: string;
};

export type TAdminGetMeetings = {
  limit?: number;
  offset?: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  courseId?: string;
  tutorId?: string;
  studentId?: string;
  lessonType?: string;
  countOnly?: boolean;
};

const apiDataProvider = new APIDataProvider();

export const adminGetMeetings = createAsyncThunk(
  '/admin/schedule/meetings',
  async ({
    limit,
    offset,
    sortKey,
    sortValue,
    startDate,
    endDate,
    courseId,
    tutorId,
    studentId,
    lessonType,
    countOnly,
  }: TAdminGetMeetings) => {
    let path = `${AdminApiPaths.schedule}/meetings?`;

    if (limit) {
      path += `&limit=${limit}`;
    }

    if (limit) {
      path += `&offset=${offset}`;
    }

    if (sortKey) {
      path += `&sortKey=${sortKey}`;
    }

    if (sortValue) {
      path += `&sortValue=${sortValue}`;
    }

    if (startDate) {
      path += `&startDate=${startDate}`;
    }

    if (endDate) {
      path += `&endDate=${endDate}`;
    }

    if (courseId) {
      path += `&courseId=${courseId}`;
    }

    if (tutorId) {
      path += `&tutorId=${tutorId}`;
    }

    if (studentId) {
      path += `&studentId=${studentId}`;
    }

    if (lessonType) {
      path += `&lessonType=${lessonType}`;
    }

    if (countOnly) {
      path += `&countOnly=1`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<
        TApiPaginationResponse<ISection & { students: IUser[] }> & {
          totalDuration: number;
        }
      >
    >(path);

    return response.data;
  }
);

export const getUserSchedulesAsAdmin = createAsyncThunk(
  '/admin/schedule/getByUserId',
  async (data: TAdminGetUserSchedule) => {
    let path = `${AdminApiPaths.schedule}/list/${data.userId}?userId=${data.userId}&startDate=${data.startDate}&endDate=${data.endDate}`;

    if (data.courseId) {
      path += `&courseId=${data.courseId}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<IAdminUserScheduleData>
    >(path);

    return response.data;
  }
);

export const getScheduleByIdAsAdmin = createAsyncThunk(
  '/admin/schedule/getOneBySectionId',
  async (data: TAdminGetScheduleById) => {
    const path = `${AdminApiPaths.schedule}/${data.sectionId}?sectionId=${data.sectionId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IScheduleFullEvent>
    >(path);

    return response.data;
  }
);
